export default "__VITE_PUBLIC_ASSET__1622182e__"